"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.availableLanguages = exports.DEFAULT_FORMAT = exports.LANGUAGE_TOPIC = exports.DEFAULT_LANGUAGE = void 0;
exports.DEFAULT_LANGUAGE = 'en';
exports.LANGUAGE_TOPIC = 'i18n/language';
exports.DEFAULT_FORMAT = 'MM/dd/yyyy';
var available_languages_1 = require("./available-languages");
Object.defineProperty(exports, "availableLanguages", { enumerable: true, get: function () { return available_languages_1.availableLanguages; } });
//# sourceMappingURL=index.js.map